module.exports = __webpack_public_path__ + "img/threeBg.d2a02e6a.jpg";